"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILanguage = void 0;
var ILanguage;
(function (ILanguage) {
    ILanguage["fr"] = "fr";
    ILanguage["en"] = "en";
})(ILanguage = exports.ILanguage || (exports.ILanguage = {}));
